module.exports = __webpack_public_path__ + "c11c476d66a6904e6055468bbb33387c.png";